import React from 'react';
import IndexPage from '../index-table/IndexPage';
import AuditTable from './AuditTable';

export default class AuditIndexPage extends React.Component {

    render() {
        return (
            <IndexPage
                title={this.props.options.title}
                titleComponentClass={this.props.titleComponentClass}
                indexTablePagerVisible={false}
                options={this.props.options}
                columns={this.props.columns}
                results={this.props.results}
                paging={this.props.paging}
                filter={this.props.filter}
                indexApiService={this.props.indexApiService}
                tableComponentClass={AuditTable}
            />
        );
    }
}